export default __webpack_public_path__ + "static/media/xls.f7ad5380.png";